import {z} from 'zod'

export const confirmationPinSchema = z.object({
  confirmationPin: z.string().optional()
})
